<template>
  <div class="step-2">
    <div class="step-2-num">
      <div class="step-2-num-text">本终端接入：</div>
      <NfDropdownMenu
        width="100%"
        height=".8rem"
        :value.sync="formValue.num"
        :options="numOptions"
      />
    </div>
    <div class="step-2-num">
      <template v-if="formValue.isPass">
        <div class="step-2-num-text">游戏密码：</div>
        <NfInput round=".5rem" :value.sync="formValue.password"  type="password" />
      </template>
    </div>

    <div class="step-2-people">
      <div class="step-2-people-text">希望被如何称呼：</div>
      <template v-for="(item, index) in formValue.personList">
        <div class="step-2-people-item" :key="index">
          <div class="step-2-people-item-text">参与者{{ index + 1 }}：</div>
          <NfDropdownMenu
            width="100%"
            :value.sync="item.playerType"
            :options="typeOptions"
            height=".8rem"
            style="margin-right: 0.1rem"
          />
          <NfInput round=".5rem" :value.sync="item.nickName" />
        </div>
      </template>

      <!-- <div class="step-2-people-item">
        <div class="step-2-people-item-text">参与者2：</div>
        <NfDropdownMenu
          width="100%"
          :value.sync="value1"
          :options="numOptions"
          height=".8rem"
          style="margin-right: 0.1rem"
        />
        <NfInput round=".5rem" />
      </div>
      <div class="step-2-people-item">
        <div class="step-2-people-item-text">参与者3：</div>
        <NfDropdownMenu
          width="100%"
          :value.sync="value1"
          :options="numOptions"
          height=".8rem"
          style="margin-right: 0.1rem"
        />
        <NfInput round=".5rem" />
      </div> -->
    </div>
  </div>
</template>

<script>
import NfDropdownMenu from "@/components/game-ui/NfDropdownMenu.vue";
import NfInput from "@/components/game-ui/NfInput.vue";
export default {
  components: {
    NfDropdownMenu,
    NfInput,
  },
  data() {
    return {
      value1: "父亲",
      numOptions: [
        { text: "1人", value: 1 },
        { text: "2人", value: 2 },
        { text: "3人", value: 3 },
      ],
      typeOptions: [
        { text: "父亲", value: "父亲" },
        { text: "母亲", value: "母亲" },
        { text: "孩子", value: "孩子" },
        { text: "兄弟", value: "兄弟" },
        { text: "姐妹", value: "姐妹" },
        { text: "爷爷", value: "爷爷" },
        { text: "奶奶", value: "奶奶" },
        { text: "叔叔", value: "叔叔" },

      ],
    };
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
  },
  computed: {
    formValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", {
          ...val,
        });
      },
    },
  },
  watch: {
    // "formValue.playersNum": {
    //   handler(val) {
    //     if (val == 1) {
    //       this.$dialog.message("状态错误");
    //     }
    //     if (val == 2) {
    //       this.numOptions = [{ text: "1人", value: 1 }];
    //     } else if (val == 3) {
    //       this.numOptions = [
    //         { text: "1人", value: 1 },
    //         { text: "2人", value: 2 },
    //       ];
    //     } else if (val == 4) {
    //       this.numOptions = [
    //         { text: "1人", value: 1 },
    //         { text: "2人", value: 2 },
    //         { text: "3人", value: 3 },
    //       ];
    //     }
    //   },
    //   immediate: true,
    // },

    "formValue.num": {
      handler(val) {
        this.formValue.personList = [];
        for (let i = 0; i < val; i++) {
          this.formValue.personList.push({
            playerType: "父亲",
            name: "",
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.step-2 {
  font-size: 0.25rem;

  &-num {
    display: flex;
    align-items: center;
    margin-bottom: 0.3rem;
    font-weight: 600;
    &-text {
      flex-shrink: 0;
    }
  }
  &-people {
    &-text {
      font-weight: 600;
    }
    &-item {
      margin: 0.3rem 0;
      display: flex;
      justify-content: space-between;
      &-text {
        flex-shrink: 0;
        color: #666666;
        font-size: 0.25rem;
      }
      display: flex;
      align-items: center;
    }
  }
}
</style>
